export default __webpack_public_path__ + "static/media/character_lose.8c274b95.mp3";